import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  IconButton,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Edit,
} from '@mui/icons-material';
import { useFeathers } from '../../app/util';
import { DataDetailToolbar } from '../../components';
import StateDistrictConfiguration from '../../components/StateDistrictConfiguration';
import StateElectionConfiguration from '../../components/StateElectionConfiguration';

const StateConfig = () => {
  const matchName = useParams().matchName;
  const feathers = useFeathers();
  const history = useHistory();
  const [stateConfig, setStateConfig] = useState(null);
  const [editing, setEditing] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0 = Basic Setup, 1 = District Setup

  // Load state config name for display
  React.useEffect(() => {
    if (feathers && matchName) {
      const stateCode = matchName.split('-')[0];
      feathers.getService('state-configurations').get(stateCode)
        .then(config => setStateConfig(config))
        .catch(console.error);
    }
  }, [feathers, matchName]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // Reset editing state when switching tabs
    setEditing(false);
  };

  return (
    <Wrapper>
      <DataDetailToolbar
        navTree={[
          { text: 'States', to: '/states' },
          { text: stateConfig?.stateName || '--', to: `/states/${matchName}` },
          { text: 'Edit configuration' },
        ]}
        onBack={() => history.push(`/states/${matchName}`)}
        actionButtonsComponent={
          !editing && (
            <IconButton
              onClick={() => setEditing(true)}
            >
              <Edit />
            </IconButton>
          )
        }
      />
      <div style={{ height: '10px' }} />
      {!editing && (
        <TabsWrapper>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Basic Setup" />
            <Tab label="District Setup" />
          </Tabs>
        </TabsWrapper>
      )}
      {activeTab === 0 && (
        <StateElectionConfiguration
          editing={editing}
          onEditingChange={setEditing}
        />
      )}
      {activeTab === 1 && (
        <StateDistrictConfiguration
          editing={editing}
          onEditingChange={setEditing}
        />
      )}
    </Wrapper>
  );
};


const Wrapper = styled.div`
    width: calc(100% - 2 * 24px);
    display: flex;
    flex-direction: column;
    padding: 24px;
    align-items: stretch;
    max-width: 800px;
`;

const TabsWrapper = styled.div`
  margin: 0 0 10px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default StateConfig;
